import React from 'react';
import SvgSprite from 'react-svg-sprite'

const Sprite = () => {
	return (
		<SvgSprite
			style={{
				position: "absolute",
				top: "-99999px",
				left: "-99999px",
				zIndex: "19999999",
				display: "block"
			}}
			symbols={[
				{
					name: "arrow",
					svg: `
					<svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 15L8 8L1 0.999999" fill="none" />
					</svg>`
				},
				{
					name: "arrow-reverse",
					svg: `
					<svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 15L0.999999 8L8 0.999999" fill="none"/>
					</svg>
					`
				},
        {
          name: "arrow-color-reverse",
          svg: `
						<svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11 1L1 11L11 21" fill="none" />
						</svg>
					`
        },
        {
          name: "arrow-color",
          svg: `
						<svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 1L11 11L1 21" fill="none" />
						</svg>
					`
        },
        {
          name: "play",
          svg: `
						<svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.41431 1.69437L14.0625 10.8643L1.41431 20.0342L1.41431 1.69437Z"/>
						</svg>
					`
        },
        {
          name: "close",
          svg: `
					<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
					        <g id="Artboard-Copy-27" transform="translate(-362.000000, -777.000000)" stroke="#FFFFFF" stroke-width="2">
					            <g id="close" transform="translate(363.000000, 778.000000)">
					                <path d="M0,0 L18,18" id="Path-6"></path>
					                <path d="M0,18 L18,0" id="Path-7"></path>
					            </g>
					        </g>
					    </g>
					</svg>
					`
        },
				{
					name: "gallery-left",
					svg: `
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="M14.283 3.50106L6.51005 11.4751C6.37352 11.6151 6.29712 11.803 6.29712 11.9986C6.29712 12.1942 6.37352 12.382 6.51005 12.5221L14.283 20.4991C14.3466 20.5644 14.4227 20.6163 14.5067 20.6517C14.5906 20.6872 14.6809 20.7054 14.772 20.7054C14.8632 20.7054 14.9534 20.6872 15.0374 20.6517C15.1214 20.6163 15.1975 20.5644 15.261 20.4991C15.3919 20.3651 15.4651 20.1853 15.4651 19.9981C15.4651 19.8108 15.3919 19.631 15.261 19.4971L7.95155 11.9986L15.261 4.50156C15.3914 4.36768 15.4644 4.18819 15.4644 4.00131C15.4644 3.81443 15.3914 3.63494 15.261 3.50106C15.1975 3.43575 15.1214 3.38383 15.0374 3.34839C14.9534 3.31294 14.8632 3.29468 14.772 3.29468C14.6809 3.29468 14.5906 3.31294 14.5067 3.34839C14.4227 3.38383 14.3466 3.43575 14.283 3.50106Z"/>
					</svg>
					`
				},
				{
					name: "gallery-right",
					svg: `
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.98899 3.49956C7.85816 3.63351 7.78491 3.81332 7.78491 4.00056C7.78491 4.1878 7.85816 4.36762 7.98899 4.50156L15.2985 12.0001L7.98899 19.4971C7.85816 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85816 20.3651 7.98899 20.4991C8.05259 20.5644 8.12862 20.6163 8.21261 20.6517C8.29659 20.6872 8.38683 20.7054 8.47799 20.7054C8.56915 20.7054 8.65939 20.6872 8.74338 20.6517C8.82736 20.6163 8.9034 20.5644 8.96699 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96699 3.50106C8.9034 3.43575 8.82736 3.38383 8.74338 3.34839C8.65939 3.31294 8.56915 3.29468 8.47799 3.29468C8.38683 3.29468 8.29659 3.31294 8.21261 3.34839C8.12862 3.38383 8.05259 3.43575 7.98899 3.50106V3.49956Z" />
					</svg>
					`
				},
        {
					name: "pause",
					svg: `
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path d="M 6 5 L 6 19 L 10 19 L 10 5 L 6 5 z M 14 5 L 14 19 L 18 19 L 18 5 L 14 5 z"></path>
						</svg>
					`
				}
			]}
		/>
	)
};

export default Sprite;
